<script setup>
import { ref } from 'vue';

defineProps({
    files: {
        required: true,
    }
});

const activeIndex = ref(0);

const onSwiperActiveIndexChange = (event) => {
    const index = event.target.swiper?.activeIndex;

    if (typeof index !== 'undefined') {
        activeIndex.value = index;
    }
}
</script>

<template>
    <div class="size-full relative bg-[#000000]" v-if="files?.length > 0">
        <swiper-container
            ref="swiper"
            class="h-full"
            :slides-per-view="1"
            @swiperactiveindexchange="onSwiperActiveIndexChange"
            >
            <swiper-slide v-for="file in files">
                <div class="size-full relative">
                    <div class="size-full blur-sm drop-shadow-none" :style="{
                        'background-image': `url(${file.url})`,
                        'background-position': 'center',
                        'background-repeat': 'no-repeat',
                        'background-size': 'cover',
                    }">
                    </div>
                    <div class="absolute z-10 size-full flex items-center justify-center top-0 bg-[#000000]/70">
                        <img class="w-full h-auto max-w-full max-h-full object-cover" :src="file.url" />
                    </div>
                </div>
            </swiper-slide>
        </swiper-container>
        <div v-if="files.length > 1" class="flex gap-1 rounded-full w-fit mx-auto bg-[#000000]/40 px-2 py-2 absolute z-10 bottom-2 left-0 right-0">
            <button
                v-for="f, i in files" class="bg-[#ffffff] size-2 rounded-full"
                type="button"
                :aria-label="`go to slide ${i + 1}`"
                :class="{
                    'bg-opacity-20': i !== activeIndex
                }"
                ></button>
        </div>
    </div>
</template>
